import { CALL_API } from '../middleware/api'

export const REDEEMCODES_REQUEST = 'REDEEMCODES_REQUEST'
export const REDEEMCODES_SUCCESS = 'REDEEMCODES_SUCCESS'
export const REDEEMCODES_FAILURE = 'REDEEMCODES_FAILURE'

export function fetchRedeemCodes(customer, code_type) {
  const params = new URLSearchParams();
  if (customer) params.append('customer', customer);
  if (code_type) params.append('code_type', code_type);
  const query = params.toString() ? `?${params.toString()}` : '';
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `swap-code${query}`,
      authenticated: true,
      types: [REDEEMCODES_REQUEST, REDEEMCODES_SUCCESS, REDEEMCODES_FAILURE]
    }
  }
}

export const REDEEMCODE_REQUEST = 'REDEEMCODE_REQUEST'
export const REDEEMCODE_SUCCESS = 'REDEEMCODE_SUCCESS'
export const REDEEMCODE_FAILURE = 'REDEEMCODE_FAILURE'

export function fetchRedeemCode(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `swap-code/${id}`,
      authenticated: true,
      types: [REDEEMCODE_REQUEST, REDEEMCODE_SUCCESS, REDEEMCODE_FAILURE]
    }
  }
}

export const REDEEMCODE_ADD_REQUEST = 'REDEEMCODE_ADD_REQUEST'
export const REDEEMCODE_ADD_SUCCESS = 'REDEEMCODE_ADD_SUCCESS'
export const REDEEMCODE_ADD_FAILURE = 'REDEEMCODE_ADD_FAILURE'

export function addRedeemCode(redeemCode) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'swap-code',
      authenticated: true,
      body: JSON.stringify(redeemCode),
      types: [REDEEMCODE_ADD_REQUEST, REDEEMCODE_ADD_SUCCESS, REDEEMCODE_ADD_FAILURE]
    }
  }
}

export const REDEEMCODE_UPDATE_REQUEST = 'REDEEMCODE_UPDATE_REQUEST'
export const REDEEMCODE_UPDATE_SUCCESS = 'REDEEMCODE_UPDATE_SUCCESS'
export const REDEEMCODE_UPDATE_FAILURE = 'REDEEMCODE_UPDATE_FAILURE'

export function updateRedeemCode(id, redeemCode) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `swap-code/${id}`,
      authenticated: true,
      body: JSON.stringify(redeemCode),
      types: [REDEEMCODE_UPDATE_REQUEST, REDEEMCODE_UPDATE_SUCCESS, REDEEMCODE_UPDATE_FAILURE]
    }
  }
}

export const REDEEMCODE_DELETE_REQUEST = 'REDEEMCODE_DELETE_REQUEST'
export const REDEEMCODE_DELETE_SUCCESS = 'REDEEMCODE_DELETE_SUCCESS'
export const REDEEMCODE_DELETE_FAILURE = 'REDEEMCODE_DELETE_FAILURE'

export function deleteRedeemCode(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `swap-code/${id}`,
      authenticated: true,
      types: [REDEEMCODE_DELETE_REQUEST, REDEEMCODE_DELETE_SUCCESS, REDEEMCODE_DELETE_FAILURE]
    }
  }
}

export const WRISTBAND_REDEEMCODES_REQUEST = 'WRISTBAND_REDEEMCODES_REQUEST'
export const WRISTBAND_REDEEMCODES_SUCCESS = 'WRISTBAND_REDEEMCODES_SUCCESS'
export const WRISTBAND_REDEEMCODES_FAILURE = 'WRISTBAND_REDEEMCODES_FAILURE'

export function fetchWristbandRedeemCodes(customer) {
  const params = new URLSearchParams({ code_type: 'wristband' });
  if (customer) params.append('customer', customer);
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `swap-code?${params.toString()}`,
      authenticated: true,
      types: [WRISTBAND_REDEEMCODES_REQUEST, WRISTBAND_REDEEMCODES_SUCCESS, WRISTBAND_REDEEMCODES_FAILURE]
    }
  }
}

export const WRISTBAND_REDEEMCODE_ADD_REQUEST = 'WRISTBAND_REDEEMCODE_ADD_REQUEST'
export const WRISTBAND_REDEEMCODE_ADD_SUCCESS = 'WRISTBAND_REDEEMCODE_ADD_SUCCESS'
export const WRISTBAND_REDEEMCODE_ADD_FAILURE = 'WRISTBAND_REDEEMCODE_ADD_FAILURE'

export function addWristbandRedeemCode(redeemCode) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'swap-code',
      authenticated: true,
      body: JSON.stringify({ ...redeemCode, code_type: 'wristband' }),
      types: [WRISTBAND_REDEEMCODE_ADD_REQUEST, WRISTBAND_REDEEMCODE_ADD_SUCCESS, WRISTBAND_REDEEMCODE_ADD_FAILURE]
    }
  }
}